<template>
  <div>
    
    <Header active="0"></Header>

    <!-- 4. 教育动态和通知公告、制度汇编 -->
    <div class="content-wrapper" style="display: flex; justify-content: space-between; margin-top: 20px;">
      <div class="education-dynamic" style="width: 50%;">
        <!-- 教育动态内容 -->
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">教育动态</span>
            <span class="title-nav-en">Education News</span>
            <router-link :to="{name: 'Article', query: {nav_id: 2}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
           <!-- 幻灯片 -->
          <el-carousel height="260px" indicator-position="outside">
            <el-carousel-item class="el-carousel-item-custom" v-for="item in silder">
              <router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}"><img :src="getThumb(item.titlepics, 640)" :alt="item.title" style="width: 100%; height: 100%;"></router-link>
              <p>{{item.title}}</p>
              <div class="bg"></div>
            </el-carousel-item>
          </el-carousel>
          <!-- 新闻链接列表 -->
          <ul class="news-ul" style="margin-top: 18px;">
            <li v-for="item in silder1"><router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">{{item.title}}</router-link></li>
          </ul>
        </el-card>

      </div>

      <div class="announcements-and-regulations" style="width: 50%;">
        <el-card class="box-card"  shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">通知公告</span>
            <span class="title-nav-en">Notice and announcement</span>
            <router-link :to="{name: 'Article', query: {nav_id: 1}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <!-- 新闻链接列表 -->
          <ul class="news-ul">
            <li v-for="item in notice"><router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">{{item.title}}</router-link></li>
          </ul>
        </el-card>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">制度汇编</span>
            <span class="title-nav-en">Institutional Compilation</span>
            <router-link :to="{name: 'Article', query: {nav_id: 3}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <!-- 新闻链接列表 -->
          <ul class="news-ul">
            <li v-for="item in zhidu"><router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">{{item.title}}</router-link></li>
          </ul>
        </el-card>
      </div>
    </div>

    <!-- 5. 资源专区 -->
    <div class="resource-area content-wrapper" >
      <el-card class="box-card box-card-nobg" shadow="never" >
          <div slot="header" class="clearfix">
            <span class="title-nav">资源专区</span>
            <span class="title-nav-en">Resource area</span>
            <router-link :to="{name: 'Res', query: {nav_id: 100}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="res-title"><img src="../assets/index-1.png" />小学资源</span>
                </div>
                <div style="height: 84px;">
                  <el-tag class="res-tag" effect="dark" v-for="item in xiaoxue">
                    <router-link :to="{name: 'Res', query: {nav_id: 100, class_id: item.id}}">{{item.name}}</router-link>
                  </el-tag>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="res-title"><img src="../assets/index-1.png" />初中资源</span>
                </div>
                <el-tag class="res-tag" effect="dark" v-for="item in chuzhong">
                  <router-link :to="{name: 'Res', query: {nav_id: 100, class_id: item.id}}">{{item.name}}</router-link>
                </el-tag>
              </el-card>
            </el-col>
          </el-row>
          
          <el-row :gutter="20" style="margin-top: 20px;">
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="res-title"><img src="../assets/index-1.png" />高中资源</span>
                </div>
                <el-tag class="res-tag" effect="dark" v-for="item in gaozhong">
                  <router-link :to="{name: 'Res', query: {nav_id: 100, class_id: item.id}}">{{item.name}}</router-link>
                </el-tag>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span class="res-title"><img src="../assets/index-1.png" />试卷中心</span>
                </div>
                <el-tag class="res-tag" effect="dark" v-for="item in shijuan">
                  <router-link :to="{name: 'Res', query: {nav_id: 100, class_id: item.id}}">{{item.name}}</router-link>
                </el-tag>
              </el-card>
            </el-col>
          </el-row>
          
        </el-card>
    </div>

    <!-- 6. 学科教研方案 -->
    <div class="subject-research content-wrapper">
      <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">学科教研方案</span>
            <span class="title-nav-en">Subject Teaching and Research Plan</span>
            <router-link :to="{name: 'Article', query: {nav_id: 4}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <!-- 学科教研方案内容 -->
          <swiper ref="mySwiperx" :options="kexueOPtions">
            <swiper-slide v-for="item in xueke">
              <div class="xueke">
                <router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">
                  <img :src="item.titlepics" :alt="item.title" style="width: 100%; height: 160px;" />
                  <p>{{item.title}}</p>
                </router-link>
              </div>
            </swiper-slide>
            
          </swiper>
        </el-card>
    </div>

    <div class="subject-research content-wrapper">
      <el-card class="box-card box-card-nobg" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">校园活动方案</span>
            <span class="title-nav-en">Campus activity plan</span>
            <router-link :to="{name: 'Article', query: {nav_id: 5}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <!-- 学科教研方案内容 -->
          <swiper ref="mySwipers" :options="kexueOPtions">
            <swiper-slide v-for="item in xiaoyuan">
              <div class="xueke">
                <router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">
                  <img :src="item.titlepics" :alt="item.title" style="width: 100%; height: 160px;" />
                  <p>{{item.title}}</p>
                </router-link>
              </div>
            </swiper-slide>
          </swiper>
        </el-card>
    </div>

    

    <!-- 8. 校报期刊 -->
    <div class="content-wrapper subject-research">
      <!-- 校报期刊内容 -->
      <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="title-nav">校报期刊展示</span>
            <span class="title-nav-en">school newspaper and periodical</span>
            <router-link :to="{name: 'Article', query: {nav_id: 6}}"><el-button class="title-more" type="text">更多>></el-button></router-link>
          </div>
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="swiper-button-prev"></div>
            </el-col>
            <el-col :span="14">
              <swiper ref="mySwiperd" :options="xiaobaoOPtions">
                <swiper-slide v-for="item in xiaobao">
                  <div class="xuebao">
                    <router-link :to="{name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: item.nav_id}}">
                      <img :src="item.titlepics" :alt="item.title" style="width: 100%; height: 160px;" />
                      <p>{{item.title}}</p>
                    </router-link>
                  </div>
                </swiper-slide>
              </swiper>
            </el-col>
            <el-col :span="5">
              <div class="swiper-button-next"></div>
            </el-col>
          </el-row>
          <!-- 学科教研方案内容 -->
          
        </el-card>
    </div>

    <!-- 9. 友情链接 -->
    <div class="friendship-links" style="background-color: #badcff;">
      <!-- 友情链接内容 -->
      <div class="content-wrapper" style="background-color: #badcff;">
        <span style="color: #1680ff;">友情链接：</span>
        <a :href="item.source" target="_blank" v-for="item in youqing" ><el-tag class="res-tag" effect="dark">
                  {{item.title}}
                </el-tag>
              </a>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import { getListOptions } from '@/utils/app'
import { index as indexApi } from '@/api/index'
import { setCache, getCache } from '@/utils/cache'
import { getThumbUrl } from '@/utils/oss'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'

export default {
  data() {
    return {
      activeMenu: '2',
      kexueOPtions: {
        slidesPerView: 4,
        paginationClickable: true,
        spaceBetween: 30,
        freeMode: true
      },
      xiaobaoOPtions: {
        // nextButton: '.swiper-button-next',
        // prevButton: '.swiper-button-prev',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        slidesPerView: 4,
        centeredSlides: false,
        paginationClickable: true,
        spaceBetween: 40,
      },
      silder: null,
      silder1: null,
      notice: null,
      zhidu: null,
      xueke: null,
      xiaoyuan: null,
      xiaobao: null,
      xiaoxue: null,
      chuzhong: null,
      gaozhong: null,
      shijuan: null,
      youqing: null,
    }
  },
  components: {
    Swiper, SwiperSlide, Header, Footer
  },
  directives: {
    swiper: directive
  },
  created(){
    this.getConfig()
    this.getIndex()
  },
  methods: {
    handleMenuSelect(index) {
      // 处理菜单项选择事件
      console.log('Selected Menu:', index);
    },
    getConfig() {
      let res = getCache('index')
      this.silder =res.silder
      this.silder1 =res.silder1
      this.notice =res.notice
      this.zhidu =res.zhidu
      this.xueke =res.xueke
      this.xiaoyuan =res.xiaoyuan
      this.xiaobao =res.xiaobao
      this.youqing =res.youqing
      let configs = getCache('configs')
      this.xiaoxue = getListOptions('小学', configs[1]['children']);
      this.chuzhong = getListOptions('初中', configs[1]['children']);
      this.gaozhong = getListOptions('高中', configs[1]['children']);
      this.shijuan = configs[1]['children'];
    },
    getThumb(val, w){
      return getThumbUrl(val, w)
    },
    getIndex(){
      indexApi().then(res=> {
        setCache('configs', res.config)
        setCache('index', res)
      })
    }
  },
};
</script>

<style scoped>
/* 添加样式，可根据需要进行调整 */
.top-section {
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner {
  margin-top: 0px;
}
.el-card{
  border: 0;
}
.title-nav{
  font-size: 20px;
  font-weight: 900;
  color: #1680ff;
}
.title-more{
  float: right;
  border: 1px solid #1680ff;
  border-radius: 10px;
  padding: 5px
}
.title-nav-en{
  margin-left: 20px;
  font-size: 16px;
  color: #e5e5e5;
  text-transform: uppercase;
}
.xueke{
  height: 190px;
}
.xueke img{
  height: 160px;
}
.xueke p {
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.xuebao{
  height: 190px;
}
.swiper-button-next , .swiper-button-prev {
  position: relative;
  margin: 50px auto;
  /* margin-left: 30px; */
}
.content-wrapper {
  width: 1200px;
  margin:0 auto;
  background-color: #fff;
}
.res-title{
  font-size: 18px;
  color: #1680ff;
}
.res-title img{
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.res-tag{
  margin: 0 5px;
  cursor: pointer;
  margin-bottom: 10px;
}
.res-tag a{
  color: #fff;
}
.el-carousel-item-custom{
}
.el-carousel-item-custom img{
  border-radius: 10px;
}
.el-carousel-item-custom p {
  position: absolute;
  bottom: 0px;
  height: 30px;
  line-height: 30px;
  width: 100%;
  color: #fff;
  text-align: center;
  z-index: 2;
}
.el-carousel-item-custom .bg{
  position: absolute;
  bottom: 0px;
  height: 30px;
  line-height: 30px;
  background-color: black;
  width: 100%;
  opacity: .5;
  z-index: 1;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.news-ul li{
  border-bottom: 1px dashed #ccc;
  line-height: 40px;
  overflow: hidden;
  height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* list-style: circle; */
}
.box-card-nobg .el-card__header{
  border-bottom: 1px solid #1680ff
}

.education-dynamic,
.announcements-and-regulations,
.subject-research,
.campus-activities,
.school-journal,
.resource-area,
.friendship-links {
  box-sizing: border-box;
  padding: 20px;
}
.resource-area{
  padding-top: 0;
}
</style>
